import React from 'react'

const Loader = () => {
  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-[#FF6C6C]"></div>
    </div>
  );
}

export default Loader